import React, { useEffect } from "react"
import { Container } from "reactstrap"
import MetaTags from "react-meta-tags"
import { withRouter, Redirect } from "react-router-dom"
// import Breadcrumb from "components/Common/Breadcrumb"

// Layout Related Components
import Header from "./Header"
import SideBar from "./SideBar"

//redux
// import { useSelector, useDispatch } from "react-redux"
import { publicRoutes } from "../../routes/AppRoutes"
import Breadcrumb from "components/common/Breadcrumb"

const DashboardLayout = props => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const appName = sessionStorage.getItem("appName")
  // const currentPath = props.currentRoute.path
  let isAllow = false
  // if (currentPath.includes("/user/verify")) {
  //   isAllow = true
  // }
  // if (!isAllow) {
  //   publicRoutes.forEach(({ path }) => {
  //     if (currentPath.includes(path)) {
  //       isAllow = true
  //     }
  //   })
  // }

  // if (!isAllow) {
  //   if (props.currentUser.jotUserType != 4) {
  //     isAllow = true
  //   }
  // }
  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header
          {...props}
          title="Dashboard title"
        />
        {(props.location.pathname !== "/dashboard/home" && props.location.pathname !== "/change-password")  ? <SideBar
          currentUser={props.currentUser}
          theme="dark"
          type="default"
        // isMobile={isMobile}
        /> : null}
        <div className="main-content">
          <div className="page-content">
            <MetaTags>
              <title>
                {props.children.props.title} | Central Authorization Tool
              </title>
            </MetaTags>
            {props.parentRoute.title !== "Dashboard" && props.parentRoute.title !== "Change Password" &&
              <Breadcrumb
                title={props.currentRoute.title}
                breadcrumbItemLink={props.currentRoute.path}
                breadcrumbItemTitle={appName}
              />
            }
            <Container fluid>{props.children}</Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(DashboardLayout)
